import PhotoSizeSelectLargeOutlinedIcon from '@mui/icons-material/PhotoSizeSelectLargeOutlined'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../components/wrappers/Button'
import type { TtoggleDrawerOnMobile } from '../../../containers/Sidebar/Sidebar'
import { IMAGE_SIZES_PATH } from './paths'

export interface MenuImageSizesProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export default function MenuImageSizes({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuImageSizesProps) {
  const { formatMessage } = useIntl()

  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href={IMAGE_SIZES_PATH}
        selected={pathname.startsWith(IMAGE_SIZES_PATH)}
      >
        <ListItemIcon>
          <PhotoSizeSelectLargeOutlinedIcon />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({ id: 'avatarStudio.sidebar.imageSizes' })}
        />
      </MenuItem>
    </div>
  )
}
